<template lang="pug">
  #sections
    #header
      a(href="http://mvdf.datacivica.org/" target="_blank")
        img#mvdf(src="/assets/logos/mvdf-logo.svg")
      a(href="#home")
        img#ceav(src="/assets/logos/CEAV_logo.svg")
    #menu
      Menu
    #allSections
      Section1
      Section2
      Section3
      Section4

</template>
<script>
import Menu from "./Menu.vue"
import Section1 from "./Section1.vue"
import Section2 from "./Section2.vue"
import Section3 from "./Section3.vue"
import Section4 from "./Section4.vue"


export default {
  name: "Sections",
  components: {
    Menu,
    Section1,
    Section2,
    Section3,
    Section4,
  }
}
</script>
<style lang="scss" scoped>
#sections {
  position: relative;
}

#menu {
  float: left;
  top: 16vh;
  //height: 0px;
  left: 2rem;
  width: 0px;
  height: 80vh;
  position: sticky;
  position: -webkit-sticky; /* Safari */
  z-index: 12;
}

#header{
  width: 100%;
  height: 15vh;
  max-height: 16vh;
  position: sticky;
  top: 0;
  z-index: 10;
  #mvdf{
    height: auto;
    width: 4rem;
    position: absolute;
    top: 2rem;
    left: 2.5rem;
  }
  #ceav{
    height: 2.5rem;
    width: auto;
    position: absolute;
    top: 2.5rem;
    right: 2.5rem;
  }
}

#allSections {
  margin-top: -15.5vh;
}

@media (min-width: 992px) and (max-width: 1399px) {
  #sections #menu {
    top: 17vh;
  }
}
</style>